export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/website_content.432c7c4.svg";